module.exports = __webpack_public_path__ + "img/maintenance.0001f05e.jpg";